module.exports = __webpack_public_path__ + "img/img2_10.b5c0ecf3.jpeg";